module.exports = __webpack_public_path__ + "static/media/step-indicator-3.76517298.svg";